import { ActiveGoodHabitDonationResponse, ActiveGoodHabitVoucherResponse } from '@/src/api/models';

export function instanceOfActiveGoodHabitVoucherResponse(value?: object): value is ActiveGoodHabitVoucherResponse {
  if (!value || typeof value !== 'object') {
    return false;
  }
  if (!('donation' in value) || value['donation'] === undefined) {
    return false;
  }
  if (!('remainingAmountInCents' in value) || value['remainingAmountInCents'] === undefined) {
    return false;
  }
  return true;
}

export function instanceOfActiveGoodHabitDonationResponse(value?: object): value is ActiveGoodHabitDonationResponse {
  if (!value || typeof value !== 'object') {
    return false;
  }
  if (!('donation' in value) || value['donation'] === undefined) {
    return false;
  }
  return true;
}

export const isActiveGoodHabitResponse = (
  value?: object,
): value is ActiveGoodHabitVoucherResponse | ActiveGoodHabitDonationResponse => {
  return instanceOfActiveGoodHabitDonationResponse(value) || instanceOfActiveGoodHabitVoucherResponse(value);
};
